<key-form-builder [form]="form"
    [values]="_values"
    (onChange)="changeFormSetting($event)">
</key-form-builder>